import React from 'react';
import { Icon } from '../icons';

// Riga di KPI (stat-card) riusabile in cima alle pagine-elenco.
// Ogni item: { key, tone, icon, value, label, onClick?, active? }.
//  - tone: 'brand' | 'accent' | 'danger' | 'warn' | 'success' (colore icona/bagliore).
//  - se `onClick` è presente la card diventa un bottone che fa da filtro rapido
//    sulla tabella sottostante, con stato attivo evidenziato (`active`);
//    altrimenti è una card puramente informativa.
function KpiGrid({ items }) {
  return (
    <div className="stat-grid">
      {items.map((k) => {
        const body = (
          <>
            <div className={`stat-icon ${k.tone}`}><Icon name={k.icon} size={20} /></div>
            <div className="stat-text">
              <div className="stat-value">{k.value}</div>
              <div className="stat-label">{k.label}</div>
            </div>
          </>
        );
        return k.onClick ? (
          <button
            type="button"
            key={k.key}
            className={`stat-card stat-card--action tone-${k.tone}${k.active ? ' is-active' : ''}`}
            onClick={k.onClick}
            aria-pressed={!!k.active}
          >
            {body}
          </button>
        ) : (
          <div key={k.key} className={`stat-card tone-${k.tone}`}>{body}</div>
        );
      })}
    </div>
  );
}

export default KpiGrid;
